import styled, { css } from "styled-components";
import { breakpoints, device, getWidthRange } from "../../../../utils/responsive_utilities";
import FontGraphie from "../../shared-styles/graphieFont";
import * as C from '../../../loggedout/shared-styles/Colors'

const navBarButtonMobile = () =>{
  return css`
    ${FontGraphie(1.6,1.2,6)};
    border: 0.2rem solid ${C.indigo};
    border-radius: 3.2rem;
    cursor: pointer;
    padding: 1.2rem 2.8rem;
    
    
    &:hover{
      text-decoration: none;
      outline: none;
    }

    @media ${getWidthRange(0, breakpoints.md)} {
      ${FontGraphie(1.4,1.43,6)};
      background: ${C.buttonGrey};
      border-radius: 0.4rem;
      text-transform: none;
      border: none;
      height: 3.2rem;
      padding: 0.5rem 1.5rem 0.7rem;
      color: ${C.white};
      width: 100%;
      text-align: center;
      display: block;

      &:hover{
        color: ${C.white};
        background: ${C.buttonGrey};
      }
    }
  `;
}

export const Header = styled.div`
  top: 0px;
  left: 0;
  right: 0;
  position: fixed;
  background: ${C.white};
  height: 7.7rem;
  z-index: 999;
  transition: height .2s ease;
  border: 0.1rem solid ${C.mischka};
  @media ${getWidthRange(0, breakpoints.md)} {
    padding: 0 2rem;
  }
  @media ${getWidthRange(0, breakpoints.md)} {
    height: 6.9rem;
  }
`;
export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: auto;
  margin-left: auto;
  width: 80%;
  max-width: 100%;
  height: 7.7rem;

  @media ${device.Tablet} {
    width: auto;
    margin: auto 2rem;
  }

  @media ${getWidthRange(0, breakpoints.md)} {
    width: 100%;
  }

  @media ${getWidthRange(0, breakpoints.md)} {
    height: 6.9rem;
  }
`;
export const LeftLogo = styled.a`
  display: inline-block;
  width: 20rem;
  transition: all .2s ease;
`;
export const RightMain = styled.div`
  display: inline-block;
`;
export const NavbarButton = styled.button`
  display: none;
  background-color: transparent;
  float: right;
  padding: 0.7rem 1rem;
  margin: 0.3rem 0.5rem 0;
  border: none;
  border-radius: 0.4rem;
  @media ${getWidthRange(0, breakpoints.md)} {
    display: block;
  }
`;
export const IconBar = styled.span`
  background-color: ${C.royal};
  border-radius: 0.3rem;
  display: block;
  height: 0.4rem;
  margin-bottom: 0.5rem;
  width: 3.5rem;
`;
export const HeaderButtons = styled.div`
  display: flex;
  align-items: center;
  height: auto;

  & > *+* {
    margin-left: 1.5rem;
  }
  @media ${getWidthRange(0, breakpoints.md)} {
    flex-direction: column;
    width: 100%;
    margin-top: 6.9rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: fit-content;
    padding-bottom: 0.4rem;
    background: ${C.white};
    ${props => !props.showNavBarMenu?css`visibility:hidden;`:css``};

    & > *+* {
      margin-top: 0.2rem;
      margin-left: 0
    }
  }
`;
export const ClassCodeLogin = styled.div`
  display: flex;
  align-items: center;
  @media ${getWidthRange(0, breakpoints.md)} {
    padding: 0.2rem;
    width: 100%;
  }
`;
export const LeftEarIcon = styled.img`
  margin-right: -2.8rem;
  @media ${getWidthRange(0, breakpoints.md)} {
    display: none;
  }
`;
export const ClassLoginButton = styled.button`
  ${navBarButtonMobile()};
  background: ${C.indigo};
  color: ${C.white};
  border: none;
  
  &:hover{
    background: ${C.royal};
    color: ${C.white};
  }
`;

export const LoginButton = styled.button`
  ${navBarButtonMobile()};
  background: ${C.white};
  color: ${C.deepCoveDark};
  padding: 1rem 2.8rem;
  
  &:hover{
    border-color: ${C.royal};
    color: ${C.deepCoveDark};
  }
`;
